// Site-wide configuration
// Change these values in one place to update across all components

export const SITE_CONFIG = {
    name: 'Curie Education',
    tagline: 'Your HSC Chemistry Advantage',

    // Contact information
    contact: {
        email: 'admin@curie.au',
        location: 'Sydney, NSW, Australia'
    },

    // Social links (add as needed)
    social: {
        // twitter: 'https://twitter.com/curie',
        // instagram: 'https://instagram.com/curie',
    }
};
